import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import {
  LoginlessConversationCache,
  LoginlessWeeklyCheckinUIState,
} from "./types";
import { RootState } from "utils/redux/store";

// ------------------ State Type/Structure ------------------
export interface LoginlessWeeklyCheckinState {
  loginlessWeeklyCheckInState: LoginlessWeeklyCheckinUIState;
  completionData: {
    completedAt?: string;
    nextCheckInAvailable?: string;
  };
  loginlessConversationCache: {
    [encryptedThreadId: string]: LoginlessConversationCache;
  };
  loginlessMessageLimitReached: boolean;
}

// ------------------ InitialState ------------------
const initialState: LoginlessWeeklyCheckinState = {
  loginlessWeeklyCheckInState: "loading",
  completionData: {},
  loginlessConversationCache: {},
  loginlessMessageLimitReached: false,
};

// ------------------ Asynchronous API calls ------------------

// ------------------ Beginning of Slice Definition ------------------
export const loginlessWeeklyCheckinSlice = createSlice({
  name: "example",
  initialState,
  reducers: {
    setLoginlessConversationCache: (
      state,
      {
        payload,
      }: PayloadAction<
        LoginlessConversationCache & {
          encryptedThreadId: string;
        }
      >
    ) => {
      state.loginlessConversationCache[payload.encryptedThreadId] = {
        threadId: payload.threadId,
        userAccountId: payload.userAccountId,
        companyAccountId: payload.companyAccountId,
        messages: payload.messages,
        uiState: payload.uiState,
        messageCount: payload.messageCount,
        maxMessages: payload.maxMessages,
        isCompleted: payload.isCompleted,
        completedAt: payload.completedAt,
        nextCheckInAvailable: payload.nextCheckInAvailable,
      };
    },
    setLoginlessMessageLimitReached: (
      state,
      { payload }: PayloadAction<boolean>
    ) => {
      state.loginlessMessageLimitReached = payload;
    },
    setUIState: (
      state,
      { payload }: PayloadAction<LoginlessWeeklyCheckinUIState>
    ) => {
      state.loginlessWeeklyCheckInState = payload;
    },
    setCompletionData: (
      state,
      {
        payload,
      }: PayloadAction<{ completedAt?: string; nextCheckInAvailable?: string }>
    ) => {
      state.completionData = payload;
    },
  },
  extraReducers: (builder) => {},
});

// ------------------ Selectors ------------------
export const selectLoginlessConversationCache =
  (encryptedThreadId: string) => (state: RootState) =>
    state.loginlessWeeklyCheckin.loginlessConversationCache[encryptedThreadId];
export const selectLoginlessMessageLimitReached = (state: RootState) =>
  state.loginlessWeeklyCheckin.loginlessMessageLimitReached;
export const selectLoginlessWeeklyCheckInState = (state: RootState) =>
  state.loginlessWeeklyCheckin.loginlessWeeklyCheckInState;
export const selectCompletionData = (state: RootState) =>
  state.loginlessWeeklyCheckin.completionData;

export const {
  setLoginlessConversationCache,
  setLoginlessMessageLimitReached,
  setUIState,
  setCompletionData,
} = loginlessWeeklyCheckinSlice.actions;

export default loginlessWeeklyCheckinSlice.reducer;
